/* eslint-disable react/no-array-index-key */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import moment from 'moment';
import { Typography } from '@material-ui/core';

import MomentLocaleUtils from 'react-day-picker/moment';
import DayPicker from 'components/DayPicker';
import EPeriodType from '@lc/legacy/src/enum/EPeriodType';


const CalendarBooking = ({ classes, availability, periodType, onDaySelect, chosenPeriods }) => {
  const { t } = useTranslation(['translations']);
  
  const { calendar, periods } = availability;
  const totalPeriods = calendar.periods.length;
  const lastDay = Object.keys(periods).reverse()[0];
  const dayFullAvailable = Object.keys(periods).filter(day => periods[day].length === totalPeriods);
  const dayPartialAvailable = Object.keys(periods).filter(
    day => periods[day].length < totalPeriods && periods[day].length,
  );
  const dayNoAvailable = Object.keys(periods).filter(day => periods[day].length === 0);

  const modifiers = {
    fullAvailable: dayFullAvailable.map(day => moment(day).toDate()),
    partialAvailable: dayPartialAvailable.map(day => moment(day).toDate()),
    disabled: dayNoAvailable.map(day => moment(day).toDate()),
    chosenPeriod: chosenPeriods ? Object.keys(chosenPeriods).map(day => moment(day).toDate()) : [],

    sunday: { daysOfWeek: [0] },
  };

  const minDate = moment();
  const maxDate = moment(lastDay);

  return (
    <div className={classes.calendar}>
      <DayPicker
        localeUtils={MomentLocaleUtils}
        locale="pt-br"
        className="Selectable"
        numberOfMonths={1}
        initialMonth={new Date(minDate)}
        fromMonth={new Date(minDate.format('YYYY/MM'))}
        toMonth={new Date(maxDate.format('YYYY/MM'))}
        disabledDays={[
          {
            before: minDate.toDate(),
          },
        ]}
        onDayClick={(day, { disabled, fullAvailable, partialAvailable }) => {
          if (!disabled && (partialAvailable || fullAvailable)) {
            onDaySelect(day);
          }
        }}
        modifiers={modifiers}
      />
      <div className={classes.labelContainer}>
        <div className={classes.labelGreen} />
        <Typography variant="caption" style={{ marginLeft: '6px' }}>
          {periodType === EPeriodType.HOURS ? t('translations:calendarLegendHours') : t('translations:calendarLegend')}
        </Typography>
      </div>
      <div className={classes.labelContainer}>
        <div className={classes.labelOrange} />
        <Typography variant="caption" style={{ marginLeft: '6px' }}>
          {periodType === EPeriodType.HOURS ? t('translations:calendarLegendPartialHours') : t('translations:calendarLegendPartial')}
        </Typography>
      </div>
    </div>
  );
};
const styles = () => ({
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  labelGreen: {
    // display: 'inline-block',
    minWidth: '16px',
    minHeight: '16px',
    backgroundColor: '#CEE9DF',
  },
  labelOrange: {
    // display: 'inline-block',
    minWidth: '16px',
    minHeight: '16px',
    backgroundColor: '#f0b60f66',
  },
  calendar: {
    '& .DayPicker-Day--today': {
      color: '#797979',
    },
    '& .DayPicker-Day--chosenPeriod': {
      color: '#000',
    },
    '& .DayPicker-Day--fullAvailable:not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled)': {
      backgroundColor: '#CEE9DF',
    },
    '& .DayPicker-Day--partialAvailable:not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled)': {
      backgroundColor: '#f0b60f66',
    },
  },
});
CalendarBooking.propTypes = {
  availability: PropTypes.object.isRequired,
  chosenPeriods: PropTypes.object,
  classes: PropTypes.object.isRequired,
  onDaySelect: PropTypes.func.isRequired,
  periodType: PropTypes.string
};
CalendarBooking.defaultProps = {
  chosenPeriods: undefined,
  periodType: EPeriodType.PERIOD
};
export default withStyles(styles)(CalendarBooking);
